import React from "react";

const CopyRighSectionComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    // <div className="copyright-area">
    // <div className="col-xl-12 col-lg-12 text-center text-lg-center">
    //   <div
    //     className="copyright-text text-center"
    //     style={{ textAlign: "center" }}
    //   >
    <div className="container copyright_made_with">
      <p className="copyright-text">
        Copyright &copy; {currentYear}, All Right Reserved
      </p>
      <p className="made_with_container">
        Made with{" "}
        <span>
          {" "}
          <i className="fas fa-heart" aria-hidden="true"></i>
        </span>{" "}
        from India
      </p>
    </div>
    //   </div>
    // </div>
    //  </div>
  );
};

export default CopyRighSectionComponent;
